import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'hub-sub-menu',
  template: `<ng-container *ngIf="hubID"><sub-menu [options]="subMenu"></sub-menu></ng-container>`,
})


export class HubSubMenuComponent implements OnInit {
  static singleton: HubSubMenuComponent;
  subMenu = <SubMenuOption[]>[];
  hubID: number;
  hub: Hub;
  errorMessage: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    HubSubMenuComponent.singleton = this;
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.subscribe(
      (params: Params) => {
        let hubId = +params['hubid'];
        this.setHubID(hubId);
        if (hubId) {
          this.hubService.getHub(hubId).subscribe(
            hub => this.setHub(hub),
            error => this.errorMessage = <any>error,
          );
        }
      }
    );
  }

  setHub(hub: Hub) {
    this.hub = hub;
  }

  static getHub(): Hub {
    if (HubSubMenuComponent.singleton && HubSubMenuComponent.singleton.hub) return HubSubMenuComponent.singleton.hub;
    return new (Hub);
  }

  setHubID(hubId: number): void {
    this.subMenu = <SubMenuOption[]>[
      { route: `/hub/${hubId}`, title: 'Overview' },
      { route: `/hub/${hubId}/health`, title: 'Health' },
      { route: `/hub/${hubId}/comms`, title: 'Comms' },
      { route: `/hub/${hubId}/actions`, title: 'Actions' },
      { route: `/hub/${hubId}/meter_readings`, title: 'Meter Readings' },
      { route: `/hub/${hubId}/schedule`, title: 'Schedule' },
      { route: `/hub/${hubId}/messages`, title: 'Messages' },
      { route: `/hub/${hubId}/installation`, title: 'Installation' },
      { route: `/hub/${hubId}/pairings`, title: 'Pairings' },
      { route: `/hub/${hubId}/spend`, title: 'Spend' },
      { route: `/hub/${hubId}/oil`, title: 'Oil' },
      { route: `/hub/${hubId}/reboots`, title: 'Reboots' },
    ];
    if (hubId) {
      let title = 'Overview';
      for (let i = 1; i < this.subMenu.length; i++) {
        if (this.router.url === this.subMenu[i].route) {
          title = this.subMenu[i].title;
          break;
        }
      }
      AppComponent.SetTitle(`Hub ${hubId} ${title}`);
      this.hubID = hubId;
    }
  }
}
